import script from "./MonthYearPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthYearPicker.vue?vue&type=script&setup=true&lang=js"

import "./MonthYearPicker.vue?vue&type=style&index=0&id=627ae6c4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-627ae6c4"]])

export default __exports__